import { Component, OnInit } from '@angular/core';
import { DataModel } from '../../../../models/data.model';
import { AngularFirestore } from '../../../../node_modules/angularfire2/firestore';
import { ActivatedRoute, Router } from '../../../../node_modules/@angular/router';

@Component({
    selector: 'app-configs',
    templateUrl: 'configs.component.html',
    styles: [``]
})
export class ConfigsComponent implements OnInit {
    item: any = {};
    banner: any = {};
    app_android:any={};

    configs: DataModel<any>;
    app_demo: any = {};
    constructor(
        private db: AngularFirestore,
        private router: Router,
    ) {
        this.configs = new DataModel<any>(db, '');
        this.configs.tableNameFull = 'config';  // nao tem prefixo
        this.configs.openDoc('splash',
            d => {
                this.item = d;
            }
        );
        this.configs.openDoc('app_demo', d => {
            this.app_demo = d;
        });
        this.configs.openDoc('banner', d => {
            this.banner = d;
        });
        this.configs.openDoc('app_android', d => {
            this.app_android = d;
        });
    }

    ngOnInit(): void { }


    doChangeImage(event) {
        console.log(event);
        this.item.img = event;
    }

    doChangeImageBanner(event) {
        console.log(event);
        this.banner.img = event;
    }

    doChangeImage_app_android(event){
        this.app_android.img = event;
    }


    doPostItem() {
        this.item.tipo = 'splash';
        this.configs.updateOrInsert('splash', this.item);
        this.configs.updateOrInsert('app_demo', this.app_demo);
        this.configs.updateOrInsert('banner', this.banner);
        this.configs.updateOrInsert('app_android', this.app_android);
        this.router.navigate(['/menu']);
    }

    doCancelItem() {
        this.router.navigate(['/menu']);
    }

}
